<template>
  <div>
    <form>
      <div class="form-wrap">
        <template
          v-if="Object.keys(confirmProductRestrictionErrors).length">
          <alert-view
            :errors="confirmProductRestrictionErrors" />
        </template>
        <div
          class="form-group form-group-confirm">
          <div class="form-label">
            <label
              class="control-label">配信エリア</label>
          </div>
          <div class="form-item">
            <span
              class="form-item-confirm-text">
              <span v-if="country === 'WW'">世界(日本を含む)</span>
              <span v-else-if="country === 'JP'">国内</span>
              <span v-else-if="country === 'WW|-JP'">日本以外の世界</span>
              <span v-else>その他</span>
            </span>
          </div>
        </div>
        <div
          class="form-group form-group-confirm">
          <div class="form-label">
            <label
              class="control-label">配信希望日</label>
          </div>
          <div class="form-item">
            <span
              v-if="simultaneousRelease"
              class="form-item-confirm-text">
              {{ publishedDate | formatDate('YYYY年MM月DD日') }}
              <span v-if="status === 0">以降</span>
            </span>
            <span
              v-else
              class="form-item-confirm-text">
              配信ストアごとに指定
            </span>
          </div>
        </div>
        <div
          v-if="subscriptionProviders.length > 0"
          class="form-group-wrap form-group-confirm">
          <div class="form-group-wrap__title">配信先ストア</div>
          <div class="check-list-heading">
            <span class="check-list-heading__title">サブスクリプション配信</span>
          </div>
          <ul
            v-for="provider in subscriptionProviders"
            :key="provider.key"
            class="check-list">
            <li
              class="check-list__node word-break">
              {{ provider.display_name }}
              <span v-if="!simultaneousRelease || status > 0">
                <span v-if="hasProviderSchedules(provider.key)">
                  (楽曲ごとに設定)
                  <div
                    v-for="(disc, dIndex) in discs"
                    :key="dIndex">
                    <div
                      v-for="(track, tIndex) in disc.tracks"
                      :key="tIndex">
                      ・ {{ tIndex + 1 }}.
                      {{ track.title_ja }}: ({{ track.restrictions[provider.key] | date }})
                    </div>
                  </div>
                </span>
                <span v-else>
                  <span
                    v-if="!(unReleasedPairProviders[provider.key] && resetting)
                      && !blankScheduleProviders[provider.key]">
                    ({{ providerSchedules[provider.key] | date }})
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div class="form-group form-group-confirm">
          <div class="form-label">
            <label
              class="control-label">ダウンロード価格</label>
          </div>
          <div class="form-item">
            <div>
              <div>
                <span
                  v-if="singlePrice"
                  class="form-item-confirm-text">
                  単曲のダウンロード価格 {{ singlePrice }}円
                </span>
                <span
                  v-else
                  class="form-item-confirm-text">
                  単曲販売なし
                </span>
                <span
                  v-if="packagePrice"
                  class="form-item-confirm-text">
                  パッケージのダウンロード価格 {{ packagePrice }}円
                </span>
                <span
                  v-else
                  class="form-item-confirm-text">
                  パッケージ販売なし
                </span>
              </div>
              <div v-if="isHiRes">
                <span
                  v-if="hiResSinglePrice"
                  class="form-item-confirm-text">
                  単曲のダウンロード価格（ハイレゾ版） {{ hiResSinglePrice }}円
                </span>
                <span
                  v-else
                  class="form-item-confirm-text">
                  （ハイレゾ版）単曲販売なし
                </span>
                <span
                  v-if="hiResPackagePrice"
                  class="form-item-confirm-text">
                  パッケージのダウンロード価格（ハイレゾ版） {{ hiResPackagePrice }}円
                </span>
                <span
                  v-else
                  class="form-item-confirm-text">
                  （ハイレゾ版）パッケージ販売なし
                </span>
              </div>
              <p
                v-if="status !== 0"
                class="form-item-text pcmt10">
                ※ダウンロード価格は設定された価格に近しい値が各ストア毎に設定されます。<br>
                ※ダウンロード価格はあくまでも参考値であり、配信ストア側によって変更される場合があります。
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="downloadProviders.length > 0"
          class="form-group-wrap form-group-confirm">
          <div class="check-list-heading">
            <span class="check-list-heading__title">ダウンロード配信</span>
          </div>
          <ul
            v-for="provider in downloadProviders"
            :key="provider.key"
            class="check-list">
            <li class="check-list__node word-break">
              {{ provider.display_name }}
              <span v-if="!simultaneousRelease || status > 0">
                <span v-if="hasProviderSchedules(provider.key)">
                  (楽曲ごとに設定)
                  <div
                    v-for="(disc, dIndex) in discs"
                    :key="dIndex">
                    <div
                      v-for="(track, tIndex) in disc.tracks"
                      :key="tIndex">
                      ・ {{ tIndex + 1 }}.
                      {{ track.title_ja }}: ({{ track.restrictions[provider.key] | date }})
                    </div>
                  </div>
                </span>
                <span v-else>
                  <span
                    v-if="!(unReleasedPairProviders[provider.key] && resetting)
                      && !blankScheduleProviders[provider.key]">
                    ({{ providerSchedules[provider.key] | date }})
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div
          v-if="databaseProviders.length > 0"
          class="form-group-wrap form-group-confirm">
          <div class="check-list-heading">
            <span class="check-list-heading__title">その他</span>
          </div>
          <ul
            v-for="provider in databaseProviders"
            :key="provider.key"
            class="check-list">
            <li
              class="check-list__node word-break">
              {{ provider.display_name }}
              <span v-if="!simultaneousRelease || status > 0">
                <span v-if="hasProviderSchedules(provider.key)">
                  (楽曲ごとに設定)
                  <div
                    v-for="(disc, dIndex) in discs"
                    :key="dIndex">
                    <div
                      v-for="(track, tIndex) in disc.tracks"
                      :key="tIndex">
                      ・ {{ tIndex + 1 }}.
                      {{ track.title_ja }}: ({{ track.restrictions[provider.key] | date }})
                    </div>
                  </div>
                </span>
                <span v-else>
                  ({{ providerSchedules[provider.key] | date }})
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div
          v-if="false"
          class="release-status-area__item-direction-btn-wrap c-btn-back-store">
          <div
            class="c-btn-release c-btn-release--edit"
            @click.prevent="onEditClicked">
            <span>編集する</span>
          </div>
        </div>
      </div>
    </form>
    <div
      v-if="status === 0 || (resetting && status === 2)"
      class="release-caution-area u-no-margin-top">
      <div class="release-caution-area__title">【ご注意】</div>
      <div class="release-caution-area__paragraph">
        <ul class="c-indent-list">
          <li
            class="c-indent-list__node">
            私は、利用規約に同意のうえ配信を依頼します。
          </li>
          <li
            class="c-indent-list__node">
            私は、本リリースに関し、選択した全ての地域において配信する正当な権利を保持しています。
          </li>
          <li
            class="c-indent-list__node">
            私は、本リリースが原則として自動更新となることを確認しました。
          </li>
          <li
            class="c-indent-list__node">
            私は、未成年ではありません。または保護者の同意を得ました。
          </li>
          <li
            class="c-indent-list__node">
            <b>配信審査依頼後はリリース情報の変更はできません。</b>
          </li>
          <li
            class="c-indent-list__node">
            <b>不正行為に該当するとみなされた再生は収益の計上から除外される場合もありますことをご了承ください。</b>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="status === 0 || (resetting && status === 2)"
      class="confirm-checkbox-area">
      <div class="checkbox">
        <label>
          <input
            v-model="confirmed"
            type="checkbox"
            @change.prevent="onConfirmedClicked">
          <div
            class="option-input"></div>
          注意事項を確認しました
        </label>
      </div>
    </div>
    <template v-if="isBtoC">
      <template v-if="status === 0 || (resetting && status === 2)">
        <copyright-caution />
      </template>
      <div
        v-if="status === 0 || (resetting && status === 2)"
        class="confirm-checkbox-area">
        <div class="checkbox">
          <label>
            <input
              v-model="copyrightCautionConfirmed"
              type="checkbox"
              @change.prevent="onConfirmedClicked">
            <div class="option-input"></div>
            注意事項を確認しました
          </label>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import AlertView from '../../AlertView'
import CopyrightCaution from '../../Copyright/CopyrightCaution'

export default {
  name: 'ReleaseStep3Confirm',
  components: {
    AlertView,
    CopyrightCaution,
  },
  filters: {
    date(value) {
      if (!value) {
        return ''
      }
      return moment(new Date(value.length === 10 ? value : value.substr(0, 10))).format('YYYY年MM月DD日')
    },
  },
  props: {
    country: {
      type: String,
      required: true,
    },
    status: {
      type: Number,
      required: true,
    },
    selectedProviders: {
      type: [Object, Array],
      required: true,
    },
    releasedProviders: {
      type: [Object, Array],
      required: true,
    },
    providers: {
      type: Array,
      required: true,
    },
    providerSchedules: {
      type: [Object, Array],
      required: true,
    },
    simultaneousRelease: {
      type: Boolean,
      required: true,
    },
    singlePrice: {
      type: [String, Number],
      required: true,
    },
    packagePrice: {
      type: [String, Number],
      required: true,
    },
    hiResSinglePrice: {
      type: [String, Number],
      required: true,
    },
    hiResPackagePrice: {
      type: [String, Number],
      required: true,
    },
    isHiRes: {
      type: Boolean,
      required: true,
    },
    publishedDate: {
      type: [String, Object],
      required: false,
      default: null,
    },
    discs: {
      type: Array,
      required: true,
    },
    resetting: {
      type: Boolean,
      default: false,
    },
    unReleasedPairProviders: {
      type: [String, Object],
      required: false,
      default: null,
    },
    blankScheduleProviders: {
      type: [String, Object],
      required: false,
      default: null,
    },
    confirmProductRestrictionErrors: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      confirmed: false,
      copyrightCautionConfirmed: false,
    }
  },
  computed: {
    downloadProviders() {
      const providers = this.providers
        .filter(provider => ((this.country === 'WW')
          || (this.country === 'JP' && provider.for_domestic)
          || (this.country === 'WW|-JP' && provider.for_worldwide))
          && this.selectedProviders[provider.key]
          && !provider.is_subscription && !provider.is_database_service)
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
      return this.resetting
        ? providers.filter(provider => !this.releasedProviders[provider.key])
        : providers
    },
    subscriptionProviders() {
      const providers = this.providers
        .filter(provider => ((this.country === 'WW')
          || (this.country === 'JP' && provider.for_domestic)
          || (this.country === 'WW|-JP' && provider.for_worldwide))
          && this.selectedProviders[provider.key]
          && provider.is_subscription && !provider.is_database_service)
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
      return this.resetting
        ? providers.filter(provider => !this.releasedProviders[provider.key])
        : providers
    },
    databaseProviders() {
      const providers = this.providers
        .filter(provider => this.selectedProviders[provider.key] && provider.is_database_service)
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
      return this.resetting
        ? providers.filter(provider => !this.releasedProviders[provider.key])
        : providers
    },
  },
  methods: {
    onEditClicked() {
      this.$emit('onEditClicked')
    },
    onConfirmedClicked() {
      this.$emit('confirmed', this.isBtoC
        ? (this.confirmed && this.copyrightCautionConfirmed)
        : this.confirmed)
    },
    // 曲ごとの設定があるかどうか。
    hasProviderSchedules(providerKey) {
      let prevDate = ''
      const result = this.discs.filter(disc => disc.tracks.filter(track => {
        if (!track.restrictions || !track.restrictions[providerKey]) {
          return false
        }
        const releaseDate = moment(new Date(track.restrictions[providerKey])).format('YYYY-MM-DD')
        const result2 = prevDate && releaseDate !== prevDate
        prevDate = releaseDate
        return result2
      }).length > 0)
      return result.length > 0
    },
  },
}
</script>

<style scoped>
.check-list {
  margin-bottom: 20px;
}
.word-break {
  word-break: break-all;
}
.c-btn-back-store{
  padding-top: 1em;
  padding-bottom: 1em;
}
</style>
